<div class="col cad cad--otEmail">
	<div class="card border-0 ps-item align-items-center justify-content-center">
		<a class="stretched-link cad__lnk" href="#" role="button" onclick="event.preventDefault(); if (typeof Fun.Media.DeviceType !== 'undefined' && typeof EngagementProvider.DisplaySignup !== 'undefined') { var unit = (Fun.Media.DeviceType == 'Mobile') ? '{{MobileCreativeId}}' : '{{DesktopCreativeId}}'; EngagementProvider.DisplaySignup(unit) };">
			<img class="card-img-top cad__img cad__img--bg" src={{ImageUrl}} alt="{{ImageAlternateText}}" />
			<img class="cad__img cad__img--text cad__img--center" src="{{TextUrl}}" alt="{{AlternateText}}" />
		</a>
	</div>
</div>